export const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export function getApiUrl() {
    // eslint-disable-next-line no-restricted-globals
    const loc = location.origin;

    if (isDev) {
        return process.env.REACT_APP_DEMO_API_URL;
    }

    return `${loc.replace(/\/$/, '')}${process.env.REACT_APP_LIVE_API_URL}`;
}

export default null;
